const layerMetric = (layer, id, label, addressId) => {
  if (!layer || layer.status === "unavailable") return null;
  const count = layer.matching_record_count;
  return {
    id,
    label,
    value: `${count} mapped record${count === 1 ? "" : "s"} within 1 km`,
    status: layer.status,
    source_name: layer.source_name,
    source_url: layer.source_url,
    licence: layer.licence,
    observation_period: layer.observation_period,
    retrieved_at: layer.retrieved_at,
    geography_type: "address_point",
    geography_id: addressId,
    derivation: `${layer.scope} ${layer.distance_method}`,
    attribution: layer.attribution,
  };
};

export function reportMetrics(metrics = [], locality, addressId, fallbackGuide) {
  const layers = new Map(
    (locality?.layers || []).map((layer) => [layer.id, layer]),
  );
  const replacements = {
    rent: fallbackGuide
      ? {
          id: "rent",
          label: `${fallbackGuide.rentDwelling} rent benchmark`,
          value: fallbackGuide.weeklyRent,
          unit: "AUD/week",
          status: "observed",
          source_name: "Residential Tenancies Authority",
          source_url:
            "https://www.rta.qld.gov.au/sites/default/files/2023-04/rta-bond-statistics.xlsx",
          licence: "CC BY 3.0 AU",
          observation_period: "2026 Q2",
          retrieved_at: "2026-10-31T00:00:00+10:00",
          geography_type: "postcode",
          geography_id: fallbackGuide.postcode,
          sample_count: fallbackGuide.rentSample,
          derivation: `Median weekly rent for ${fallbackGuide.rentSample} new tenancies in postcode ${fallbackGuide.postcode}; not a property-specific appraisal.`,
          attribution: "© Residential Tenancies Authority Queensland",
        }
      : null,
    transport: layerMetric(
      layers.get("bus_stops"),
      "transport",
      "Nearby bus-stop records",
      addressId,
    ),
    neighbourhood: layerMetric(
      layers.get("parks"),
      "neighbourhood",
      "Nearby council park records",
      addressId,
    ),
  };
  return metrics
    .filter((metric) => metric.id !== "purchase_costs")
    .map((metric) =>
      metric.status === "unavailable" && replacements[metric.id]
        ? replacements[metric.id]
        : metric,
    );
}

